import StepNavigator from './StepNavigator';
import './StepNavigator.scss';

export default StepNavigator;
